export default "__VITE_ASSET__DIeOjE3G__"